(function () {
  var STORAGE_KEY = "web-night-book-v1";

  function boot() {
    var root = document.querySelector('.puzzle-page[data-puzzle="night-book"]');
    if (!root || root.getAttribute("data-booted") === "1") return;
    root.setAttribute("data-booted", "1");
    startPuzzle(root);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  function startPuzzle(root) {
    function q(id) { return root.querySelector("#" + id); }

    var nodes = {
      dek: q("dek"),
      letter: q("letter"),
      progress: q("progress"),
      status: q("status"),
      tabs: q("tabs"),
      pageView: q("page-view"),
      answerForm: q("answer-form"),
      codeInput: q("code-input"),
      check: q("check"),
      reveal: q("reveal"),
      spoil: q("spoil"),
      spoilYes: q("spoil-yes"),
      spoilNo: q("spoil-no"),
    };

    var state = null;

    function book() {
      var api = globalThis.NightBook;
      if (!api) throw new Error("NightBook is missing");
      return api;
    }

    function setStatus(text, kind) {
      nodes.status.textContent = text;
      nodes.status.className = kind || "";
    }

    function blankState() {
      return { version: 1, page: 1, solved: {}, drafts: {} };
    }

    function load() {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return blankState();
      var parsed = JSON.parse(raw);
      var next = blankState();
      if (parsed && parsed.page >= 1 && parsed.page <= 7) next.page = parsed.page;
      if (parsed && parsed.solved && typeof parsed.solved === "object") next.solved = parsed.solved;
      if (parsed && parsed.drafts && typeof parsed.drafts === "object") next.drafts = parsed.drafts;
      return next;
    }

    function save() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: 1,
        page: state.page,
        solved: state.solved,
        drafts: state.drafts,
      }));
    }

    function solvedCount() {
      return book().PAGES.filter(function (page) { return state.solved[page.page]; }).length;
    }

    function renderLetter() {
      nodes.letter.replaceChildren();
      book().introParagraphs.forEach(function (text) {
        var p = document.createElement("p");
        p.textContent = text;
        nodes.letter.append(p);
      });
    }

    function render() {
      var api = book();
      var current = api.pageByNumber(state.page);
      var locked = Boolean(state.solved[current.page]);
      nodes.progress.textContent = solvedCount() + " of 7 codes entered.";
      nodes.tabs.replaceChildren();
      api.PAGES.forEach(function (page) {
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = String(page.page);
        button.setAttribute("aria-label", "Page " + page.page + (state.solved[page.page] ? ", entered" : ""));
        if (page.page === state.page) button.setAttribute("aria-current", "true");
        if (state.solved[page.page]) button.className = "solved";
        button.addEventListener("click", function () {
          state.page = page.page;
          save();
          setStatus("", "");
          render();
        });
        nodes.tabs.append(button);
      });
      nodes.pageView.replaceChildren();
      var title = document.createElement("h2");
      title.textContent = "Page " + current.page + ". " + current.title;
      nodes.pageView.append(title);
      current.lines.forEach(function (line) {
        var p = document.createElement("p");
        p.className = "page-copy";
        p.textContent = line;
        nodes.pageView.append(p);
      });
      var ask = document.createElement("p");
      ask.className = "ask";
      ask.textContent = current.ask;
      nodes.pageView.append(ask);
      if (current.page === 7) {
        api.PAGES.slice(0, 6).forEach(function (page) {
          if (!state.solved[page.page]) return;
          var known = document.createElement("p");
          known.className = "known";
          known.textContent = "Page " + page.page + " code: " + page.answer;
          nodes.pageView.append(known);
        });
      }
      nodes.codeInput.value = locked ? current.answer : (state.drafts[current.page] || "");
      nodes.codeInput.disabled = locked;
      nodes.check.disabled = locked;
      nodes.reveal.hidden = locked;
    }

    function openSpoil() {
      nodes.spoil.hidden = false;
      nodes.spoilNo.focus();
    }

    function closeSpoil() {
      nodes.spoil.hidden = true;
      if (!nodes.reveal.hidden) nodes.reveal.focus();
    }

    nodes.codeInput.addEventListener("input", function () {
      if (state.solved[state.page]) return;
      state.drafts[state.page] = nodes.codeInput.value;
      save();
    });

    nodes.answerForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var api = book();
      var page = api.pageByNumber(state.page);
      if (state.solved[page.page]) return;
      if (!api.foldTight(nodes.codeInput.value)) {
        setStatus("Enter the code for this page.", "");
        return;
      }
      if (api.accepts(page, nodes.codeInput.value)) {
        state.solved[page.page] = true;
        state.drafts[page.page] = page.answer;
        save();
        setStatus("Yes. The code for page " + page.page + " is " + page.answer + ".", "ok");
        render();
        return;
      }
      setStatus("No. That code does not fit this page.", "bad");
    });

    nodes.reveal.addEventListener("click", openSpoil);
    nodes.spoilYes.addEventListener("click", function () {
      var page = book().pageByNumber(state.page);
      closeSpoil();
      state.solved[page.page] = true;
      state.drafts[page.page] = page.answer;
      setStatus("The code for page " + page.page + " is " + page.answer + ".", "ok");
      save();
      render();
    });
    nodes.spoilNo.addEventListener("click", closeSpoil);
    nodes.spoil.addEventListener("click", function (event) {
      if (event.target === nodes.spoil) closeSpoil();
    });

    root.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !nodes.spoil.hidden) closeSpoil();
    });

    nodes.dek.textContent = book().DEK;
    book().assertBook();
    renderLetter();
    state = load();
    render();
  }
})();
